module.exports = __webpack_public_path__ + "img/custom-survery.35c66ef1.svg";